import type { User } from "@/types/user";

export function getUserName(user?: User): string {
  if (!user) return "-";

  const first = user.additional_info?.first_name?.trim();
  const last = user.additional_info?.last_name?.trim();

  // Case: first name + last name
  if (first && last) {
    return `${first.charAt(0).toUpperCase()}. ${last}`;
  }

  // Case: just first name
  if (first) {
    return first;
  }

  // Case: just last name
  if (last) {
    return last;
  }

  // Case: complete name in user.name
  if (user.name) {
    const parts = user.name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return `${parts[0].charAt(0).toUpperCase()}. ${parts.slice(1).join(" ")}`;
    }
    return user.name;
  }

  return user.username || "User";
}
